// /src/pages/GcuPage.jsx

import React from 'react';
import PublicLexicalPage from '../components/PublicLexicalPage';

function GcuPage() {
  return (
    <PublicLexicalPage 
      documentName="GCU"
      layout="classic"
    />
  );
}

export default GcuPage;
